import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';

export async function submitIntakeLead(data) {
  await addDoc(collection(db, 'rda_intake_leads'), {
    full_name: data.fullName,
    whatsapp: data.whatsapp,
    relato_breve: data.brief,
    attachments: data.attachments,
    status: 'pending',
    created_at: serverTimestamp(),
    source: 'public_intake_form',
    auth_uid: data.uid,
    auth_is_anonymous: data.isAnonymous,
  });
}
